/* AestheticsXart - display-only USD/EUR price converter. Checkout always charges USD. */
(function () {
  if (window.axCurrencyLoaded) return;
  window.axCurrencyLoaded = true;

  var KEY = 'axCurrency';
  var RATE_KEY = 'axRateUsdEur';
  var FALLBACK_RATE = 0.89;
  var TTL = 12 * 60 * 60 * 1000;
  var RATE_URL = 'https://api.frankfurter.dev/v1/latest?base=USD&symbols=EUR';
  var RE = /\$\s?(\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(\s?USD)?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, TEMPLATE: 1 };
  var NOTE_TEXT = 'Prices in EUR are estimates based on today’s exchange rate. You’ll be charged in USD at checkout.';

  var html = document.documentElement;

  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function write(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  var currency = read(KEY) === 'EUR' ? 'EUR' : 'USD';
  var rate = FALLBACK_RATE;
  var cached = null;
  try {
    cached = JSON.parse(read(RATE_KEY) || 'null');
  } catch (e) {}
  if (cached && cached.rate > 0) rate = cached.rate;

  var records = new Map();

  function formatEur(amount) {
    var parts = amount.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + parts.join('.');
  }

  function convertString(value) {
    return value.replace(RE, function (match, number, usd) {
      var amount = parseFloat(number.replace(/,/g, '')) * rate;
      return formatEur(amount) + (usd ? ' EUR' : '');
    });
  }

  function skipNode(node) {
    var el = node.parentElement;
    if (!el) return true;
    if (SKIP[el.tagName]) return true;
    if (el.closest('[data-ax-no-convert]')) return true;
    return false;
  }

  function convertTextNode(node) {
    var value = node.nodeValue;
    if (!value || value.indexOf('$') === -1) return;
    var rec = records.get(node);
    if (rec && value === rec.converted) return;
    if (skipNode(node)) return;
    RE.lastIndex = 0;
    if (!RE.test(value)) return;
    RE.lastIndex = 0;
    var converted = convertString(value);
    records.set(node, { original: value, converted: converted });
    node.nodeValue = converted;
  }

  function convertTree(root) {
    if (!root) return;
    if (root.nodeType === 3) return convertTextNode(root);
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    var nodes = [];
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(convertTextNode);
  }

  function restoreAll() {
    records.forEach(function (rec, node) {
      if (node.nodeValue === rec.converted) node.nodeValue = rec.original;
    });
    records.clear();
  }

  function addNotes() {
    document.querySelectorAll('.tax-note').forEach(function (anchor) {
      var container = anchor.parentElement;
      if (!container || container.querySelector(':scope > .ax-cur-note')) return;
      var note = document.createElement('p');
      note.className = 'ax-cur-note';
      note.setAttribute('data-ax-no-convert', '');
      note.textContent = NOTE_TEXT;
      anchor.insertAdjacentElement('afterend', note);
    });
  }

  function updateUi() {
    html.classList.toggle('ax-cur-eur', currency === 'EUR');
    document.querySelectorAll('[data-ax-currency]').forEach(function (btn) {
      btn.setAttribute('aria-current', btn.getAttribute('data-ax-currency') === currency ? 'true' : 'false');
    });
  }

  function apply() {
    updateUi();
    if (currency === 'EUR') {
      convertTree(document.body);
      addNotes();
    } else {
      restoreAll();
    }
    html.classList.remove('ax-eur-pending');
  }

  var queue = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var items = queue;
    queue = [];
    if (currency !== 'EUR') return;
    items.forEach(convertTree);
    addNotes();
  }
  var observer = new MutationObserver(function (mutations) {
    if (currency !== 'EUR') return;
    mutations.forEach(function (m) {
      if (m.type === 'characterData') queue.push(m.target);
      else m.addedNodes.forEach(function (n) { queue.push(n); });
    });
    if (!scheduled && queue.length) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-ax-currency]');
    if (!btn) return;
    event.preventDefault();
    var next = btn.getAttribute('data-ax-currency') === 'EUR' ? 'EUR' : 'USD';
    var details = btn.closest('details');
    if (details) details.removeAttribute('open');
    if (next === currency) return;
    currency = next;
    write(KEY, currency);
    apply();
  });

  function refreshRate() {
    if (cached && cached.rate > 0 && Date.now() - cached.t < TTL) return;
    fetch(RATE_URL)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var fresh = data && data.rates && data.rates.EUR;
        if (!(fresh > 0)) return;
        write(RATE_KEY, JSON.stringify({ rate: fresh, t: Date.now() }));
        if (Math.abs(fresh - rate) < 0.00001) return;
        rate = fresh;
        if (currency === 'EUR') {
          restoreAll();
          convertTree(document.body);
        }
      })
      .catch(function () {});
  }

  function init() {
    apply();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    refreshRate();
  }

  setTimeout(function () {
    html.classList.remove('ax-eur-pending');
  }, 2500);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* Account sheet: Collector's Circle perk note for signed-out visitors */
(function(){
  function addPerk(el){
    try{
      var data=document.getElementById('shopify-customer-account-data');
      if(data&&JSON.parse(data.textContent).customer)return;
      var root=el.shadowRoot;if(!root)return;
      var content=root.querySelector('.account__content');
      if(!content||root.querySelector('.ax-perk'))return;
      var st=document.createElement('style');
      st.textContent='.ax-perk{display:flex;gap:10px;align-items:flex-start;margin:0 0 4px;padding:12px 14px;border:1px solid rgba(184,151,90,.5);background:#fffdf8;font-size:13px;line-height:1.45;color:rgba(27,26,23,.78)}.ax-perk b{display:block;font-family:Cormorant,serif;font-size:17px;font-weight:600;color:#1b1a17;margin-bottom:2px}.ax-perk i{font-style:normal;color:#b8975a;font-size:14px;line-height:1.3}';
      var d=document.createElement('div');d.className='ax-perk';
      d.innerHTML='<i>&#10022;</i><span><b>Join the Collector&rsquo;s Circle</b>Tick &ldquo;Email me with news and offers&rdquo; for 10% off your first artwork, plus one masterpiece story a week.</span>';
      root.appendChild(st);content.insertBefore(d,content.firstChild);
    }catch(e){}
  }
  function bind(){
    document.querySelectorAll('shopify-account').forEach(function(el){
      if(el.dataset.axPerk)return;el.dataset.axPerk='1';
      el.addEventListener('open',function(){setTimeout(function(){addPerk(el)},0)});
      el.addEventListener('click',function(){setTimeout(function(){addPerk(el)},60)});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
})();


/* Gallery cards: detect the artwork's real shape (crop the transparent mockup margin) and fit the mat to it */
(function(){
  var KEY='axArt';
  function load(){try{return JSON.parse(localStorage.getItem(KEY)||'{}')}catch(e){return {}}}
  function save(c){try{localStorage.setItem(KEY,JSON.stringify(c))}catch(e){}}
  function apply(a,d){
    a.parentNode.classList.add('ax-card--'+d[0]);
    var s=a.querySelector('.ax-card__art');if(!s)return;
    s.style.cssText='--ar:'+d[1]+';--bw:'+d[2]+';--bh:'+d[3]+';--x0:'+d[4]+';--y0:'+d[5];
    s.classList.add('is-cropped');
  }
  function probe(a){
    if(a.getAttribute('data-ax-done'))return;
    a.setAttribute('data-ax-done','1');
    var key=a.getAttribute('data-ax-m'),c=load();
    if(c[key]){apply(a,c[key]);return;}
    var im=new Image();
    im.onload=function(){
      try{
        var W=im.naturalWidth,H=im.naturalHeight,cv=document.createElement('canvas');cv.width=W;cv.height=H;
        var cx=cv.getContext('2d');cx.drawImage(im,0,0);var px=cx.getImageData(0,0,W,H).data;
        var x0=W,y0=H,x1=-1,y1=-1;
        for(var y=0;y<H;y++)for(var x=0;x<W;x++){if(px[(y*W+x)*4+3]>200){if(x<x0)x0=x;if(x>x1)x1=x;if(y<y0)y0=y;if(y>y1)y1=y;}}
        if(x1<0){x0=0;y0=0;x1=W-1;y1=H-1;}
        var bw=(x1-x0+1)/W,bh=(y1-y0+1)/H,ar=(bw*W)/(bh*H),r=function(n){return Math.round(n*10000)/10000};
        var d=[ar>1.12?'land':ar<0.89?'port':'sq',r(ar),r(bw),r(bh),r(x0/W),r(y0/H)];
        c=load();c[key]=d;save(c);apply(a,d);
      }catch(e){}
    };
    im.src=a.getAttribute('data-ax-probe');
  }
  function scan(){document.querySelectorAll('.ax-card__media[data-ax-m]').forEach(probe);}
  var t;
  function later(){clearTimeout(t);t=setTimeout(scan,120);}
  function init(){scan();new MutationObserver(later).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


/* Mobile filter drawer: keep "Show N works" in sync with the live result count */
(function(){
  function sync(){
    var src=document.getElementById('ProductCount');if(!src)return;
    var m=(src.textContent||'').match(/\d+/);if(!m)return;
    var n=parseInt(m[0],10);
    var w=n===1?'work':'works';
    document.querySelectorAll('[data-ax-show-count]').forEach(function(el){if(el.textContent!==String(n))el.textContent=n;});
    document.querySelectorAll('[data-ax-show-word]').forEach(function(el){if(el.textContent!==w)el.textContent=w;});
  }
  function init(){
    sync();
    new MutationObserver(function(){sync();}).observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();




/* Wishlist page (Heartify): gallery heading, artist/title split, "Choose size & finish", guest note, empty state */
(function(){
  function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML;}
  function init(){
    var page=document.querySelector('[data-hfy-page]');
    if(!page||page.dataset.axWl)return;
    page.dataset.axWl='1';
    var grid=page.querySelector('[data-hfy-grid]');
    var title=page.querySelector('.hfy-page-title');
    var guest=!page.getAttribute('data-customer-id');
    if(title){title.innerHTML='<span class="ax-wl-eyebrow">Your private gallery</span>Saved <em>masterpieces</em><span class="ax-wl-meta" data-ax-wl-meta></span>';}
    var empty=page.querySelector('[data-hfy-empty]');
    if(empty){
      var h=empty.querySelector('.hfy-empty-heading');if(h)h.innerHTML='Your gallery walls are <em>still bare</em>';
      var t=empty.querySelector('.hfy-empty-text');if(t)t.textContent='Tap the ♡ on any artwork and it will wait for you here, ready whenever you are.';
      var b=empty.querySelector('.hfy-btn');if(b){b.innerHTML='Explore the collection <span aria-hidden="true">&rarr;</span>';b.setAttribute('href','/collections/all');}
      if(!empty.querySelector('.ax-wl-alt')){var a=document.createElement('span');a.className='ax-wl-alt';a.innerHTML='or see our <a href="/collections/new-arrivals">newest arrivals</a>';empty.appendChild(a);}
    }
    var note=null;
    if(guest){
      note=document.createElement('div');note.className='ax-wl-note';note.hidden=true;
      var login=page.getAttribute('data-login-url')||'/account';
      note.innerHTML='<p><span aria-hidden="true">&#10022;</span>Saved on this device. Sign in to keep your gallery on every device and never lose a favourite.</p><a href="'+esc(login)+'">Sign in &rarr;</a>';
      var head=page.querySelector('.hfy-page-head');if(head)head.insertAdjacentElement('afterend',note);
    }
    function enhance(){
      if(!grid)return;
      var cards=grid.querySelectorAll('.hfy-card');
      cards.forEach(function(card,i){
        if(card.dataset.axWl)return;card.dataset.axWl='1';
        card.style.animationDelay=(i*70)+'ms';
        var tl=card.querySelector('.hfy-card-title');
        if(tl&&tl.textContent.indexOf(' by ')>-1){
          var full=tl.textContent.trim(),k=full.lastIndexOf(' by ');
          var art=full.slice(k+4),name=full.slice(0,k);
          tl.textContent=name;
          var s=document.createElement('span');s.className='ax-wl-artist';s.textContent=art;tl.insertAdjacentElement('beforebegin',s);
        }
        var pr=card.querySelector('.hfy-card-price');
        if(pr&&!card.querySelector('.ax-wl-from')){var f=document.createElement('span');f.className='ax-wl-from';f.textContent='From';pr.insertAdjacentElement('beforebegin',f);}
        var acts=card.querySelector('.hfy-card-actions');var url=(card.querySelector('.hfy-card-media')||{}).getAttribute&&card.querySelector('.hfy-card-media').getAttribute('href');
        if(acts&&url&&!acts.querySelector('.ax-wl-cta')){var c=document.createElement('a');c.className='ax-wl-cta';c.href=url;c.innerHTML='Choose size &amp; finish <span aria-hidden="true">&rsaquo;</span>';acts.appendChild(c);}
      });
      var n=cards.length,meta=page.querySelector('[data-ax-wl-meta]');
      if(meta)meta.textContent=n?(n+(n===1?' work':' works')+' waiting for a wall'):'';
      if(note)note.hidden=!n;
    }
    enhance();
    if(grid)new MutationObserver(enhance).observe(grid,{childList:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,1200);
})();


/* Account sheet: brand mark in the heading, icons for each shortcut, live wishlist count */
(function(){
  var MARK='https://aestheticsxart.com/cdn/shop/files/ax-logo-mark.png?width=96';
  function ic(d){return 'url("data:image/svg+xml,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+d+'</svg>')+'")';}
  var CSS=''+
    '.account__heading{display:flex;align-items:center;gap:12px;font-family:Cormorant,"Cormorant Garamond",serif;font-size:22px;font-weight:500;letter-spacing:.01em;color:#1b1a17}'+
    '.account__heading::before{content:"";flex:none;width:30px;height:32px;background:url('+MARK+') center/contain no-repeat}'+
    '.account__close{border-radius:50%!important;transition:background-color .2s ease}'+
    '.account__item{display:flex!important;align-items:center;gap:14px;padding-left:10px!important;padding-right:10px!important;border-radius:8px;transition:background-color .2s ease,color .2s ease}'+
    '.account__item::before{content:"";flex:none;width:18px;height:18px;background:#1f4e5a;-webkit-mask:var(--ax-ic) center/contain no-repeat;mask:var(--ax-ic) center/contain no-repeat}'+
    '.account__item::after{content:"\\203A";margin-left:auto;font-size:20px;line-height:1;color:#b8975a;transition:transform .2s ease}'+
    '.account__item:hover{background:rgba(237,229,214,.65)}'+
    '.account__item:hover::after{transform:translateX(3px)}'+
    '.account__item-text{font-size:15px;letter-spacing:.01em}'+
    '.account__item[href*="/orders"]{--ax-ic:'+ic('<path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/>')+'}'+
    '.account__item[href*="/profile"]{--ax-ic:'+ic('<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>')+'}'+
    '.account__item[href*="/apps/wishlist"]{--ax-ic:'+ic('<path d="M12 20.5s-8-4.6-8-10.7A4.3 4.3 0 0 1 12 7.5a4.3 4.3 0 0 1 8 2.3c0 6.1-8 10.7-8 10.7z"/>')+'}'+
    '.account__item[href*="/pages/faq"]{--ax-ic:'+ic('<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14"/><path d="M12 17.2v.1"/>')+'}'+
    '.ax-wl-count{display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;margin-left:8px;padding:0 6px;border-radius:10px;background:#1f4e5a;font-size:11px;font-weight:600;line-height:1;color:#f6f1e7}';
  function wishCount(){
    try{var n=0;for(var i=0;i<localStorage.length;i++){var k=localStorage.key(i);if(/^hfy:v2:[cg]:/.test(k)){var a=JSON.parse(localStorage.getItem(k)||'[]');if(Array.isArray(a))n=Math.max(n,a.length);}}return n;}catch(e){return 0;}
  }
  function style(el){
    var root=el.shadowRoot;if(!root)return;
    if(!root.querySelector('style[data-ax-acct]')){var st=document.createElement('style');st.setAttribute('data-ax-acct','');st.textContent=CSS;root.appendChild(st);}
    var n=wishCount();
    root.querySelectorAll('.account__item[href*="/apps/wishlist"] .account__item-text').forEach(function(t){
      var b=t.querySelector('.ax-wl-count');
      if(!n){if(b)b.remove();return;}
      if(!b){b=document.createElement('span');b.className='ax-wl-count';t.appendChild(b);}
      if(b.textContent!==String(n))b.textContent=n;
    });
  }
  function bind(){
    document.querySelectorAll('shopify-account').forEach(function(el){
      if(el.dataset.axAcct)return;el.dataset.axAcct='1';
      var run=function(){style(el);};
      el.addEventListener('open',function(){setTimeout(run,0);setTimeout(run,300);});
      el.addEventListener('click',function(){setTimeout(run,80);setTimeout(run,400);});
      if(el.shadowRoot)new MutationObserver(function(){clearTimeout(el._axT);el._axT=setTimeout(run,60);}).observe(el.shadowRoot,{childList:true,subtree:true});
      run();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
  setTimeout(bind,1500);
})();
